export const isBrowser = typeof window !== 'undefined'
export const isServer = typeof window === 'undefined'

export default {
  set: ((key, value) => localStorage.setItem(key, value)),
  get: (key => localStorage.getItem(key)),
  delete: (key => localStorage.removeItem(key)),
  clear: (() => localStorage.clear()),
}
